// extracted by mini-css-extract-plugin
module.exports = {"buttonMax":"FormAdd-module--buttonMax--3P0lR"};